module.exports = __webpack_public_path__ + "img/full6-min.b5cd3cd5.png";